var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcVerification16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16v16H0z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-verification-16_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FF4D4D",
  d: "M7.165.38a1.11 1.11 0 0 1 1.67 0l.813.954c.268.314.702.449 1.11.345l1.245-.314c.66-.167 1.313.288 1.351.94l.072 1.23c.024.404.292.758.686.904l1.2.446c.636.236.885.972.516 1.52l-.697 1.036a.995.995 0 0 0 0 1.118l.697 1.035c.37.55.12 1.285-.516 1.521l-1.2.446c-.394.146-.662.5-.686.904l-.072 1.23c-.038.652-.692 1.107-1.351.94l-1.244-.314a1.11 1.11 0 0 0-1.11.345l-.814.954a1.11 1.11 0 0 1-1.67 0l-.813-.954a1.11 1.11 0 0 0-1.11-.345l-1.245.314c-.66.167-1.313-.288-1.351-.94l-.072-1.23a1.04 1.04 0 0 0-.686-.904l-1.2-.446c-.636-.236-.885-.972-.516-1.52L.87 8.558a.995.995 0 0 0 0-1.118L.172 6.406c-.37-.55-.12-1.285.516-1.521l1.2-.446c.394-.146.662-.5.686-.904l.072-1.23c.038-.652.692-1.107 1.351-.94l1.244.314c.409.104.843-.031 1.11-.345L7.166.38Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M11.766 5.257a.94.94 0 0 1 0 1.242L7.992 10.64l-.566-.62.566.62c-.437.48-1.147.48-1.584 0l.566-.62-.566.62-2.174-2.385a.94.94 0 0 1 0-1.242.75.75 0 0 1 1.132 0L7.2 9.026l3.434-3.769a.75.75 0 0 1 1.132 0",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-verification-16_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export default SvgIcVerification16;